export class RestoreEksClusterRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "EksClusterRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEksClusterRequest.attributeTypeMap;
    }
    constructor() {
    }
}
